export default __webpack_public_path__ + "9142af5ec6eb5ab87dd83b17d8a7ddcf.glb";